// extracted by mini-css-extract-plugin
export default {"Icon":"vNQsv3Xm","IconContainer":"crVyKNO8"};